import React from 'react'

interface Props {}

const Orders: React.FC<Props> = () => {
  return <div>Orders</div>
}

export default Orders
